import { GET_CATEGORY_DATA_SUCCESS } from '../constants';

export default function categories(state = {}, action) {
  switch (action.type) {
    case GET_CATEGORY_DATA_SUCCESS:
      return {
        ...state,
        data: action.categories,
      };
    default:
      return state;
  }
}
